import * as yup from "yup";

export const getSchema = (requireAmlEntityType: boolean = false) =>
  yup.object().shape({
    // Case information card fields
    hasSubscriptionUrl: yup.string().oneOf(["yes", "no"]).required("Field required"),

    // Client and Entity are always required
    client: yup.object().nullable().required("Client (Arena) required"),
    entity: yup.object().nullable().required("Entity required"),

    // This *should* never fail:
    assignToMyself: yup.boolean().required("Field required"),

    // Investor account fields
    accountType: yup
      .string()
      .oneOf(["institution", "individual"])
      .required("Account type required"),
    taxIdType: yup.string().nullable(),
    taxId: yup.string().min(5, "Tax Id must be at least 5 characters"),
    // Entity-only fields
    entityType: yup.string().when("accountType", {
      is: "institution",
      then: (schema) => schema.required("Entity type required"),
    }),
    amlEntityType: yup.string().when("accountType", {
      is: "institution",
      then: (schema) =>
        requireAmlEntityType ? schema.required("AML entity type required") : schema,
    }),
    entityName: yup.string().when("accountType", {
      is: "institution",
      then: (schema) => schema.required("Entity name required"),
    }),

    // Individual-only fields
    firstName: yup.string().when("accountType", {
      is: "individual",
      then: (schema) => schema.required("First name required"),
    }),
    lastName: yup.string().when("accountType", {
      is: "individual",
      then: (schema) => schema.required("Last name required"),
    }),

    // Address fields
    streetLine1: yup.string(),
    streetLine2: yup.string(),
    city: yup.string(),
    stateOrProvince: yup.string(),
    country: yup.string().required("Country required"),
    zipCode: yup.string(),
  });

export const schema = getSchema();
